import { computed, onMounted, onUnmounted, ref } from 'vue';

const SCREENS = {
	SM: 320,
	MD: 768,
	LG: 1024,
	XL: 1280,
};

export function useScreenSize() {
	const screenSize = ref(0);

	function setNewScreenSize() {
		screenSize.value = window.innerWidth;
	}

	setNewScreenSize();

	onMounted(() => {
		window.addEventListener('resize', setNewScreenSize);
	});

	onUnmounted(() => {
		window.removeEventListener('resize', setNewScreenSize);
	});

	const isMobileResolution = computed(() => screenSize.value < SCREENS.MD);
	const isTabletResolution = computed(() => SCREENS.MD <= screenSize.value && screenSize.value < SCREENS.LG);
	const isDesktopResolution = computed(() => screenSize.value >= SCREENS.LG);
	const isLargeDesktopResolution = computed(() => screenSize.value >= SCREENS.XL);

	return {
		screenSize,
		isMobileResolution,
		isTabletResolution,
		isDesktopResolution,
		isLargeDesktopResolution,
  };
}
